import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import HelpMessage from "../Components/HelpMessage";
import SearchBar from "../Components/SearchBar";

import { Document, Page } from 'react-pdf';

import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

const Documents = () => {
  const [documentData, setDocumentData] = useState([]);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [currentPdf, setCurrentPdf] = useState(null);
  const [filesData, setFilesData] = useState(null);
  const [docWidth, setDocWidth] = useState(window.innerWidth * 0.9);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs';

  // on resize chagne doc width
  useEffect(() => {
    const handleResize = () => {
      setDocWidth(window.innerWidth * 0.9);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const showDocumentDetails = (document) => () => {
    let DocLink = document.Link;
    // Trim DocLink
    DocLink = DocLink.trim();

    setCurrentPdf(`${process.env.REACT_APP_API_BASEURL}/assets/documents/other/${DocLink}.pdf`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_BASEURL + "/documents", {
          headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
        });
        
        // Sort the data based on the date in ascending order
        const sortedData = response.data;
        setDocumentData(sortedData);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Documents</a>
          </div>
          <div className="" id="result-wrapper">
            <SearchBar/>

            {currentPdf ? <>
              <div className="back-button">
                <button onClick={() => setCurrentPdf(null)} className="btn btn-primary"><i className="fa fa-arrow-left"></i> Back to Documents List</button>
              </div>
              <Document
                file={currentPdf}
                
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              >
                {/* For each page in the PDF, render a Page component */}
                {Array.from({ length: numPages }, (_, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} width={docWidth} />
                ))}
              </Document>

              <div className="back-button">
                <button onClick={() => setCurrentPdf(null)} className="btn btn-primary"><i className="fa fa-arrow-left"></i> Back to Documents List</button>
              </div>

            </> : <>
              <form className="login100-form validate-form" method="post">
                <div className="container-fluid">
                  <div className="heading cst-heading row doc-head">
                    <div className="col-xs-8">
                      <div className="fil-day">DOCUMENT</div>
                    </div>

                    <div className="col-xs-4">
                      <div className="fil-vol">Date</div>
                    </div>
                  </div>
                </div>

                <div className="table-responsive custom-result">
                  <div className="doc-tbl-wrap">
                    {documentData
                      .slice()
                      .reverse()
                      .map((document) => (
                        <div className="doc-row-wrap" key={document.DocName}>
                          <div
                            className="row"
                            onClick={showDocumentDetails(document)}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <div className="col-lg-8 col-md-8 col-sm-8">
                              <span className="doc-tile">{document.DocName}</span>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4">
                              <span className="doc-date">
                                {document.FullDate}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </form>
            </>}
            <HelpMessage />
          </div>
        </div>
      </div>
    </>
  );
};

export default Documents;
